import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getEffectiveShipmentSummaryBase } from "@redotech/redo-fulfillment-group-common/shipment-summary";

function getElectronicCommercialInvoice(row: FulfillmentGroupData): string {
  const summary = getEffectiveShipmentSummaryBase(row);
  const invoiceShipment = summary?.carrierShipments.find(
    (cs) => cs.commercialInvoiceUrl,
  );
  if (!invoiceShipment) {
    return "N/A";
  }

  return invoiceShipment.comInvoiceSubmittedElectronically ? "true" : "false";
}

export const CommercialInvoiceSubmittedElectronicallyCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Comm. invoice e-submitted",
    cell: (row) => {
      return getElectronicCommercialInvoice(row);
    },
  };
